jQuery(document).ready(function( $ ){


	// PRIVACY CHECKBOX HELPER
	$("#PrivacyCheckAll").click(function(){
		if(this.checked) {
			$('.privacy-check').prop('checked', true);
		} else {
			$('.privacy-check').prop('checked', false);
		}
	});

	// END JQUERY
});


// form validation
(function() {
	'use strict';
	window.addEventListener('load', function() {
		// Fetch all the forms we want to apply custom Bootstrap validation styles to
		var forms = document.getElementsByClassName('needs-validation');
		// Loop over them and prevent submission
		var validation = Array.prototype.filter.call(forms, function(form) {
			form.addEventListener('submit', function(event) {
				if (form.checkValidity() === false) {
					event.preventDefault();
					event.stopPropagation();
				}
				form.classList.add('was-validated');
			}, false);
		});
	}, false);
})();
